__turbopack_context__.v({
  "smallScreenFix": "PostGrid-module__JKkEjW__smallScreenFix",
});
